import React, {Component} from 'react'
import apiBarcode from "../../../services/api/apiBarcode"
import {Col, Row} from "reactstrap"
import StaticsTotal from "./StaticsTotal"
import OvertimeStatistics from "../OvertimedStatisticsV2"
import PackingStatistics from "../PackingStatistics"
import { getListBoxes } from "../../../services/api/apiNextBox"

class StaticsOvertime extends Component {
    state = {
        waiting_process: '--',
        in_production: '--',
        waiting_package: '--',
        labelled: '--',
        ship_overdue_total: 0,
        waiting_package_not_packaged_items: 0,
        waiting_package_items: 0,
        waiting_package_orders: 0,
        waiting_label_orders: 0,
    }

    componentDidMount() {
        this._fetchStatistics()
        this._fetchListBoxeOvertime()
    }

    _fetchStatistics = async () => {
        try {
            const resRead = await apiBarcode.getStatisticsV4()
            const {success, data, message} = resRead.data

            if (!success) throw new Error(message)

            const {waiting_process, in_production, waiting_package, labelled, waiting_package_not_packaged_items, waiting_package_items, waiting_package_orders, waiting_label_orders} = data

            this.setState({
                waiting_process,
                in_production,
                waiting_package,
                labelled,
                waiting_package_not_packaged_items,
                waiting_package_items,
                waiting_package_orders,
                waiting_label_orders,
            })
        } catch (e) {
            alert(e.message)
        }
    }

    _fetchListBoxeOvertime = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10,
            }

            const { success, data, message: mess } = await getListBoxes(payload)

            if (!success) throw new Error(mess)

            const { ship_overdue_total } = Object.assign({}, data)


            this.setState({
                ship_overdue_total: ship_overdue_total || 0
            })
        } catch (e) {
            return this.setState({
                loading: false,
                error: e.message || e,
            })
        }
    }

    render() {
        const { waiting_process, in_production, waiting_package, labelled, ship_overdue_total, waiting_package_not_packaged_items, waiting_package_items, waiting_package_orders, waiting_label_orders } = this.state
        const statistics = { waiting_process, in_production, waiting_package, labelled, ship_overdue_total, waiting_package_not_packaged_items, waiting_package_items, waiting_package_orders, waiting_label_orders }

        return (
            <div className="StaticsOvertime">
                <Row className='text-center'>
                    <Col md={12} className="Left">
                        <StaticsTotal statistics={statistics}/>

                        <OvertimeStatistics/>
                    </Col>

                    <Col md={12} className="Right">
                        <PackingStatistics/>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default StaticsOvertime
